module.exports = "<div class=\"type\">\n    <div>\n        {{question_index}}\n        <span class=\"mandatory\" *ngIf=\"is_mandt\">*</span>. {{question_name}}\n    </div>\n    <div>\n        {{question_name_second}}\n    </div>\n    <ion-range-slider #sliderElement type=\"double\" min=\"0\" [max]=\"question_max_char\" [to]=\"question_max_char-2\">\n\n    </ion-range-slider>"


//////////////////
// WEBPACK FOOTER
// ./src/app/questions-type/range-type/range-type.component.html
// module id = ./src/app/questions-type/range-type/range-type.component.html
// module chunks = main